export enum ClassificationInputTab {
  TEXT = 'text',
  UPLOAD = 'upload',
  RECORD = 'record',
  IMAGE_URL = 'image_url',
}
